var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBidashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.507,
    height: 21.513,
    viewBox: "0 0 31.507 21.513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "BI_Dashboard_-_1",
    "data-name": "BI Dashboard - 1",
    d: "M20.082,0a9.39,9.39,0,0,1,7.861,14.524l4.064,4.428-2.8,2.561L25.282,17.2a9.392,9.392,0,0,1-10.891-.354c-.984.992-1.925,1.936-2.718,2.728L6.23,14.2,2.4,17.916l-1.9-1.9,5.763-5.6c1.8,1.8,3.579,3.579,5.4,5.374l.843-.851A9.391,9.391,0,0,1,20.082,0ZM13.945,13.478,17.7,9.691,15.462,7.458,21.744,7.4v6.338L19.6,11.594c-1.077,1.09-2.433,2.461-3.8,3.843a7.365,7.365,0,1,0-1.851-1.959Z",
    transform: "translate(-0.5)",
    fill: "#e0001b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidashboard);
export default __webpack_public_path__ + "static/media/bidashboard.eeb01b0dc3156a685f141ae999450e0f.svg";
export { ForwardRef as ReactComponent };